module.exports = __webpack_public_path__ + "img/banner3.0739993b.png";